import { MouseEvent } from 'react'
import { IWishlistButtonProps } from '@awazevr/design-system.compositions.property-card'
import { WishlistButton } from '@awazevr/design-system.components.wishlist-button'

export const ConditionalWishlistButton = ({
  label,
  wishlistButton = {
    showWishlistButton: false,
    isPropertyInWishlist: false,
    toggleWishlistItem: () => {},
  },
}: {
  label?: string
  wishlistButton?: IWishlistButtonProps
}) => {
  if (!wishlistButton.showWishlistButton) return null

  const stopCardClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    e.preventDefault()
  }

  return (
    <div role="presentation" onClick={stopCardClick}>
      <WishlistButton
        label={label ?? ''}
        isChecked={wishlistButton.isPropertyInWishlist}
        showLabel={false}
        variant="elevated"
        buttonSize={wishlistButton.buttonSize}
        throttleDuration={wishlistButton.throttleDuration}
        onClickCallback={wishlistButton.toggleWishlistItem}
      />
    </div>
  )
}
